import { render } from "./Load.vue?vue&type=template&id=3af2e9ce&scoped=true"
import script from "./Load.vue?vue&type=script&lang=js"
export * from "./Load.vue?vue&type=script&lang=js"

import "./Load.vue?vue&type=style&index=0&id=3af2e9ce&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af2e9ce"]])

export default __exports__